import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export const EKAM_SITE_LINKS = [
  ["About", "/ekam/about"],
  ["Contact", "/ekam/contact"],
  ["Trust Center", "/ekam/trust"],
  ["Security", "/ekam/security"],
  ["Terms", "/ekam/terms"],
  ["Privacy", "/ekam/privacy"],
  ["Cookies", "/ekam/cookies"],
  ["Sub-processors", "/ekam/subprocessors"],
  ["DPA / BAA", "/ekam/dpa-baa"],
  ["Service Agreement", "/ekam/service-agreement"],
];

export const EkamSiteHeader = ({ title }) => {
  const navigate = useNavigate();
  return (
    <header className="mx-auto flex max-w-4xl items-center justify-between px-6 py-6" data-testid="ekam-site-header">
      <button type="button" onClick={() => navigate("/")} data-testid="ekam-site-back-btn" className="inline-flex items-center gap-2 rounded-full border border-teal-500/15 px-4 py-2 text-sm text-slate-400 transition-colors hover:border-cyan-400/40 hover:text-cyan-200">
        <ArrowLeft size={16} /> Back to Ekam
      </button>
      <div className="text-right">
        <p className="font-display text-xl font-semibold text-white">Ekam</p>
        {title && <p className="text-[10px] uppercase tracking-[0.25em] text-cyan-300">{title}</p>}
      </div>
    </header>
  );
};

export const EkamSiteFooter = () => {
  const navigate = useNavigate();
  return (
    <footer className="mx-auto max-w-4xl px-6 pb-16" data-testid="ekam-site-footer">
      <div className="flex flex-wrap gap-x-4 gap-y-2 border-t border-teal-500/10 pt-6">
        {EKAM_SITE_LINKS.map(([label, url]) => (
          <button key={url} type="button" onClick={() => navigate(url)} data-testid={`ekam-site-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-xs text-slate-500 transition-colors hover:text-cyan-300">{label}</button>
        ))}
      </div>
      <p className="mt-4 text-[10px] text-slate-600">© 2026 Anxya Tech Private Limited (CIN: U62099PN2024PTC230490) · HQ Pune, Maharashtra, India</p>
    </footer>
  );
};
